"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScheduleEmailExistingRecipient = exports.isScheduleEmailExternalRecipient = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @internal
 */
exports.isScheduleEmailExternalRecipient = function (obj) {
    return !isEmpty_1.default(obj) && typeof obj.email === "string";
};
/**
 * @internal
 */
exports.isScheduleEmailExistingRecipient = function (obj) {
    return !isEmpty_1.default(obj) && typeof obj.user === "object";
};
//# sourceMappingURL=interfaces.js.map